// Global user store to hold the current Firebase user
// This is needed because auth.currentUser may not be immediately available
// after registration, but userCredential.user is available immediately

import { User } from 'firebase/auth';

let currentUser: User | null = null;
let isRegistering = false; // Flag to prevent clearing during registration

export const userStore = {
  setUser: (user: User | null) => {
    currentUser = user;
    if (user) {
      console.log('✅ User stored in userStore:', user.uid);
    } else {
      // Only log if we're not in the middle of registration
      if (!isRegistering) {
        console.log('🗑️ User cleared from userStore');
      }
    }
  },

  getUser: (): User | null => {
    return currentUser;
  },

  clearUser: () => {
    // Don't clear if we're in the middle of registration
    if (isRegistering) {
      console.log('⚠️ Prevented clearing userStore during registration');
      return;
    }
    currentUser = null;
    console.log('🗑️ User cleared from userStore');
  },

  setRegistering: (value: boolean) => {
    isRegistering = value;
    if (value) {
      console.log('🔒 userStore protected during registration');
    } else {
      console.log('🔓 userStore protection removed');
    }
  },
};
